import { coordinateEventModule } from "coordinate/event"
import { COORDINATE_EVENTS, ICoordinate } from "coordinate/model"

export function notifyCoordinateAdd(newCoordinate: ICoordinate): void {
  coordinateEventModule.notify(COORDINATE_EVENTS.COORDINATE_ADD, newCoordinate)
}

export function notifyCoordinateUpdate(coordinate: ICoordinate): void {
  coordinateEventModule.notify(COORDINATE_EVENTS.COORDINATE_UPDATE, coordinate)
}

export function notifyCoordinateDelete(coordinateId: number): void {
  coordinateEventModule.notify(COORDINATE_EVENTS.COORDINATE_DELETE, coordinateId)
}

export function notifyCoordinatesDelete(coordinateIds: number[]): void {
  coordinateEventModule.notify(COORDINATE_EVENTS.COORDINATES_DELETE, coordinateIds)
}

export function notifyCoordinatesSet(coordinates: ICoordinate[]): void {
  coordinateEventModule.notify(COORDINATE_EVENTS.COORDINATES_SET, coordinates)
}
